// extracted by mini-css-extract-plugin
module.exports = {"iframes_container":"MapStore_iframes_container__xTgW5"};